function defaultTextAlert() {
	$(".default-text-alert").on("click", function() {
		$(this).removeClass("default-text-alert");
	});
}